import React, { useState } from "react";
import { blockUser, unBlockUser } from "../../../../services/newUserService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../../utils/errorHandler";

const ToggleSwitch = ({ propId, initialStatus, onStatusChange }) => {
  const [isBlocked, setIsBlocked] = useState(initialStatus === "Blocked");

  const handleToggle = async () => {
    const newStatus = isBlocked ? "Unblock" : "Blocked";
    const modalTitle = isBlocked ? "Unblock User" : "Block User";
    const modalMessage = isBlocked
      ? "Are you sure you want to unblock this user?"
      : "Are you sure you want to block this user?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isBlocked) {
          await unBlockUser(propId, newStatus);
        } else {
          await blockUser(propId, newStatus);
        }
        setIsBlocked(!isBlocked);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The user has been ${
            newStatus === "Active" ? "unblocked" : "blocked"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isBlocked} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default ToggleSwitch;
